export var UniversParameterWithBindings;
(function (UniversParameterWithBindings) {
    let type;
    (function (type) {
        type["DEFAULT"] = "default";
        type["NETWORK"] = "network";
        type["POSITION"] = "position";
        type["FOOTFALL"] = "footfall";
    })(type = UniversParameterWithBindings.type || (UniversParameterWithBindings.type = {}));
})(UniversParameterWithBindings || (UniversParameterWithBindings = {}));
